import { ALL_USERS_ID } from "../constants.js";
import { UserName } from "./UserName.js";
import { useUserNames } from "../hooks/useUserNames.js";
import { useState } from "react";
import { Skeleton, Tag } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Users/shared/UserNames.tsx
var Render = ({ listAll, max, showId, truncate, users }) => {
	const [showAllUsers, setShowAllUsers] = useState(false);
	if (!listAll && users.length > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: classnames({ "line-clamp-1": truncate }),
			children: /* @__PURE__ */ jsx(UserName, {
				showId,
				user: users[0]
			})
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", users.length - 1]
		})]
	});
	return /* @__PURE__ */ jsx("span", { children: showAllUsers || !max ? users.map((user, i) => /* @__PURE__ */ jsxs("span", { children: [/* @__PURE__ */ jsx(UserName, {
		showId,
		user
	}), i + 2 <= users.length && ", "] }, user.id)) : /* @__PURE__ */ jsxs("span", { children: [users.map((user, i) => /* @__PURE__ */ jsxs("span", { children: [(!max || i + 1 <= max) && /* @__PURE__ */ jsx(UserName, {
		showId,
		user
	}), i + 1 < +users.length && (!max || i + 1 < max) && ", "] }, user.id)), !!max && users.length > max && /* @__PURE__ */ jsx("span", {
		className: "pl-xxs cursor-pointer",
		onClick: () => setShowAllUsers(true),
		children: /* @__PURE__ */ jsx(Tag, {
			value: `+${users.length - max}`,
			variant: "main"
		})
	})] }) });
};
var UserNamesFromIds = ({ listAll, max, showId, userIds }) => {
	const allUsers = userIds.includes(ALL_USERS_ID);
	const { data, loading } = useUserNames(userIds.length ? { userIds } : void 0, { cacheStrategy: "cache-only" });
	if (!data?.users && loading) return /* @__PURE__ */ jsx(Skeleton.Text, {
		chars: 12,
		inline: true,
		lines: userIds.length
	});
	if (allUsers) return /* @__PURE__ */ jsx("span", { children: "All Users" });
	if (!userIds?.length || !data?.users) return null;
	return /* @__PURE__ */ jsx(Render, {
		listAll,
		max,
		showId,
		users: data.users
	});
};
var UserNames = ({ listAll = true, max, showId, userIds, users }) => {
	if (users) return /* @__PURE__ */ jsx(Render, {
		listAll,
		max,
		showId,
		users
	});
	if (userIds) return /* @__PURE__ */ jsx(UserNamesFromIds, {
		listAll,
		max,
		showId,
		userIds
	});
	return null;
};
//#endregion
export { UserNames };

//# sourceMappingURL=UserNames.js.map